import { API_BASE_URL } from './config'
import axios from 'axios';
import router from '@/router';

class DBData {
    constructor(config) {
        this.dbname = config?.dbname || 'trackdata'
    }

    async token() {
        try {
            const token = localStorage.getItem('jwtToken');
            await axios.get(`${API_BASE_URL}/authcheck`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            return token;
        } catch (error) {
            console.error('Error authcheck:', error)
            localStorage.removeItem('jwtToken');
            router.push('/login');
            throw (error)
        }
    }

    async post(route, request) {
        const token = await this.token();

        const response = await axios.post(`${API_BASE_URL}/${route}`, request, {
            headers: { Authorization: `Bearer ${token}` },
        });

        return response.data
    }

    async get(route) {
        const token = await this.token();
        const response = await axios.get(`${API_BASE_URL}/${route}`, {
            headers: { Authorization: `Bearer ${token}` },
        });
        return response.data;
    }

    async getLiveControlState() {
        return await this.get('livecontrol/ipsw/state');
    }

    async setIpswServiceMode(mode) {
        return await this.post('livecontrol/ipsw/mode', { mode });
    }

    async setIpswVehicleMode(vehicleId, mode) {
        return await this.post(`livecontrol/ipsw/vehicle/${encodeURIComponent(vehicleId)}/mode`, { mode });
    }

    async clearIpswVehicleMode(vehicleId) {
        const token = await this.token();
        const response = await axios.delete(
            `${API_BASE_URL}/livecontrol/ipsw/vehicle/${encodeURIComponent(vehicleId)}/mode`,
            { headers: { Authorization: `Bearer ${token}` } }
        );
        return response.data;
    }

    async fetchPidEventsDayCounts() {
        try {

            let filter = {
                dbname: this.dbname
            }

            return await this.post(`piddaycount`, filter);

        } catch (error) {
            console.error('Error fetching vehicles:', error)
        }
    }

    async findStops(matchString) {
        try {

            let filter = {
                dbname: this.dbname,
                matchString: matchString
            }

            return await this.post(`findstops`, filter);

        } catch (error) {
            console.error('Error finding stops:', error)
            return [];
        }
    }

    async GetStopDetails(ref) {
        try {

            let filter = {
                dbname: this.dbname,
                reference: ref
            }

            return await this.post(`getstopdetails`, filter);

        } catch (error) {
            console.error('Error getstopdetails:', error)
            return [];
        }
    }

    async fetchStopToStopRawRoute(guid, fromstop, tostop) {
        try {

            let filter = {
                dbname: this.dbname,
                guid: guid,
                ref: fromstop + "_" + tostop
            }

            return await this.post(`fetchStopToStopRawRoute`, filter);

        } catch (error) {
            console.error('Error fetchStopToStopRawRoute:', error)
            return [];
        }
    }

    async fetchAllStops() {
        try {
            return await this.post(`fetchallstops`, { dbname: this.dbname });
        } catch (error) {
            console.error('Error fetchAllStops:', error)
            return [];
        }
    }

    async fetchAllRoutes() {
        try {
            return await this.post(`fetchallroutes`, { dbname: this.dbname });
        } catch (error) {
            console.error('Error fetchAllRoutes:', error)
            return [];
        }
    }

}

export default DBData;